import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { AuthService } from '../auth/auth.service';
import { MrhstApi } from '../repository/mrhst/mrhst.api';
import { IMrhstSearchKeyword } from '../repository/mrhst/mrhst.model';
import { StateItem } from '../state-item';

@Injectable()
export class CarMrhstSearchKeyStateItem extends StateItem<
  IMrhstSearchKeyword[]
> {
  private readonly mrhstApi = inject(MrhstApi);

  private readonly authService = inject(AuthService);

  constructor() {
    super([]);
  }

  loadSearchKeyword(): void {
    if (this.value?.length) return;
    this.mrhstApi
      .getSearchKeyword({
        mrhstType: 'CAR',
        // 로그인한 관리자의 brandId 취득
        brandId: this.authService.account.brandId,
      })
      .subscribe((list) => {
        this.setValue(list);
      });
  }

  get list$(): Observable<IMrhstSearchKeyword[]> {
    return this.value$;
  }

  get list(): IMrhstSearchKeyword[] {
    return this.value;
  }
}
